import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import { PDP_READYTOSHIP_TAB_ID } from 'commons/constants';
import ToggleButton from './ToggleButton';
const ToggleButtonGroup = t0 => {
  const $ = _c(17);
  const {
    "aria-label": ariaLabel,
    className: t1,
    items,
    selectedItem,
    size: t2,
    styling
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const size = t2 === undefined ? "sm" : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <VisuallyHidden>Clicking on one of the following buttons will update the content below.</VisuallyHidden>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const t4 = `flex flex-row list-none m-0 ${className}`;
  const t5 = styling === "ImportantToggle";
  let t6;
  if ($[1] !== t4 || $[2] !== t5) {
    t6 = classNames(t4, {
      "gap-[15px]": t5
    });
    $[1] = t4;
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== items || $[5] !== selectedItem || $[6] !== size || $[7] !== styling) {
    let t8;
    if ($[9] !== selectedItem || $[10] !== size || $[11] !== styling) {
      t8 = t9 => {
        const {
          contentId,
          id,
          label,
          description,
          isSelected,
          onClick,
          infoTooltip: t10,
          infoTooltipContent: t11
        } = t9;
        const infoTooltip = t10 === undefined ? false : t10;
        const infoTooltipContent = t11 === undefined ? "" : t11;
        return <ToggleButton styling={styling} contentId={contentId} id={id} showCloseButton={id !== PDP_READYTOSHIP_TAB_ID} iconSize={id === PDP_READYTOSHIP_TAB_ID ? "big" : "small"} isSelected={isSelected || selectedItem === id} key={id} label={label} description={description} onClick={onClick} size={size} infoTooltip={infoTooltip} infoTooltipContent={infoTooltipContent} />;
      };
      $[9] = selectedItem;
      $[10] = size;
      $[11] = styling;
      $[12] = t8;
    } else {
      t8 = $[12];
    }
    t7 = items.map(t8);
    $[4] = items;
    $[5] = selectedItem;
    $[6] = size;
    $[7] = styling;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[13] !== ariaLabel || $[14] !== t6 || $[15] !== t7) {
    t8 = <>{t3}<div aria-label={ariaLabel} className={t6} role="tablist">{t7}</div></>;
    $[13] = ariaLabel;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
ToggleButtonGroup.propTypes = {
  'aria-label': PropTypes.string.isRequired,
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    contentId: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    description: PropTypes.string,
    isSelected: PropTypes.bool,
    onClick: PropTypes.func,
    infoTooltip: PropTypes.bool,
    infoTooltipContent: PropTypes.string
  })).isRequired,
  selectedItem: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'sm']),
  styling: PropTypes.oneOf(['ImportantToggle'])
};
export default ToggleButtonGroup;